<template xmlns:v-clipboard="http://www.w3.org/1999/xhtml" xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <!--分页-->
  <!--搜索/筛选的空间  -->
  <!--  表格高度 tableHeight-->
  <!--reder-->
  <!--  代码注释-->
  <!--  素材管理->基础页-->
  <!--  新增/详情 HomePageList line 199-->
  <base-page-component :has-back="false" :has-nav="false" nav-title="引导页">
    <div style="background-color: #F4F8FF;height: calc(100% - 0px)">
      <div class="bg-white m-auto">

        <div class="flex a-center h-60">
          <Input class="m-l-25" placeholder="姓名" style="width: 240px"/>
          <Button class="m-l-15">搜索</Button>
        </div>

        <div class="m-h-25 ">
          <Table :columns="columns" :data="dataList"
                 :height="tableHeight">

            <template v-slot:copy="{row,index}">
              <div class="flex a-center">
                <div class=" icon-copy fs-20 m-l-5" style="color: #1472FF;cursor: pointer;"
                     v-clipboard:copy="row.url"
                     v-clipboard:error="onError"
                     v-clipboard:success="copy"/>

              </div>
            </template>
            <template v-slot:status="{row,index}">
              <div class="flex a-center">
                <div class="p-h-10 fs-13 flex a-center j-center p-t-2 m-r-10"
                     style="background-color: #FFF3EB;color: red;border-radius: 11px;"
                     v-if="row.status === 1">
                  超级管理员
                </div>
                <div class="p-h-10 fs-13 flex a-center j-center p-t-2 m-r-10"
                     style="background-color: #FFF3EB;color: red;border-radius: 11px;"
                     v-if="row.status === 2">
                  管理员
                </div>
              </div>
            </template>


            <template v-slot:link="{row,index}">
              <div class="flex a-center j-center">
                {{ row.url }}

              </div>
            </template>

            <template v-slot:operation="{row,index}">
              <div class="flex j-between fs-12">

                <span
                  @click="onShareSettingClick(row,index)"
                  style="color:#3B80FF;cursor: pointer">个人档案</span>
                <span @click="onPageRenovationClick(row)"
                      style="cursor: pointer;color: #3B80FF">访问记录</span>
                <!--弹窗页面标题-->
                <span
                  @click="onRenameClick(row)"
                  style="color:#3B80FF;cursor: pointer">二维码</span>
                <span
                  @click="delPage(row,index)"
                  style="color:red ;cursor: pointer">删除</span>
                <span :style="{color:getStatus(row)}"
                      @click="changeStatus(row,index)"
                      style="cursor: pointer">{{ row.status === 1 ? '停用' : '发布' }}</span>
              </div>
            </template>
          </Table>

          <Page :current="pageNum" :page-size="pageSize" :total="totalPage"
                class="m-t-10 p-b-10" show-total/>
        </div>
      </div>


    </div>

    <!--    分享设置弹框-->
    <Modal
      :closable="false"
      class="modal-setting"
      title=""
      v-model="shareModal.show"
    >
      <p class="text-center" slot="header">
        <span>{{ shareModal.title }}</span>
      </p>

      <div class="w-full flex j-center" slot="footer">
        <Button @click="shareSettingCancel">取消</Button>
        <Button @click="shareSettingOk" style="margin-left: 50px" type="primary">确定</Button>
      </div>
      <div class="flex-column a-center j-center" style="width: 550px;">
        <div class="h-400" style="position: relative;width:450px;height: 360px;">
          <!--        图片宽高比5:4-->
          <up-load-image @uploadSuccess="onUploadShareCoverSuccess($event)" accept="image/*"
                         picurl="share/icon/"
                         style="width:450px;">
            <template v-slot:tip>
              <div style="width: 450px; position: relative;left: 0;top: 0">
                <div class="flex-column a-center j-center"
                     style="width: 450px;height: 360px;background-color: #F6F9FF;cursor: pointer">
                  <img alt="" src="../../assets/common/ic_upload_picture@2x.png"
                       style="width: 96px;height: 96px">
                  <span class="m-t-5  color-66">上传图片</span>
                </div>

                <img
                  :src="shareModal.picUrl"
                  @click.stop=""
                  style="position: absolute;width: 450px;height: 360px;left: 0;top: 0;background-color: #F6F9FF;"
                  v-if="shareModal.picUrl"
                />

                <img @click.stop="onDelShareCoverSuccess()"
                     src="../../assets/common/ic_yichu.png"
                     style="position: absolute;right: -11px;top: -11px"
                     v-if="shareModal.picUrl"/>
              </div>
            </template>
          </up-load-image>

        </div>

        <Input class="m-t-20 m-b-10" placeholder="分享标题"
               style="width: 450px" v-model="shareModal.shareTitle"/>
      </div>
    </Modal>

    <!--    重置名称弹框-->
    <Modal
      :closable="false"
      class="modal-setting"
      title=" "
      v-model="renameModal.show"
      width="400px"
    >
      <!--      class-name="vertical-center-modal"-->
      <p class="text-center" slot="header">
        <span>重置名称</span>
      </p>

      <div class="w-full flex j-center" slot="footer">
        <Button @click="renameModalCancel">取消</Button>
        <Button @click="renameModalOk" style="margin-left: 50px" type="primary">确定</Button>
      </div>
      <!--      <div style="width: 400px" class="flex j-center a-center m-b-20">-->
      <Input class=" m-b-10"
             style="width: 320px" v-model="renameModal.name"/>
      <!--      </div>-->

    </Modal>

    <!--    新建页面弹框-->
    <Modal
      :closable="false"
      class="modal-setting"
      title=" "
      v-model="createPageModal.show"
      width="400px"
    >
      <!--      class-name="vertical-center-modal"-->
      <p class="text-center" slot="header">
        <span>{{ createPageModal.title }}</span>
      </p>
      <p slot="footer"></p>

      <div>
        <Input class=" m-b-10"
               placeholder="商品名称" style="width: 320px" v-model="createPageModal.pageTitle"/>
        <div class="w-full flex j-center">
          <Button @click="createPageModalCancel">取消</Button>
          <Button @click="createPageModalOk" style="margin-left: 50px" type="primary">
            {{ createPageModal.step === 1 ? '确定' : '开始装修' }}
          </Button>
        </div>
      </div>

    </Modal>

  </base-page-component>

</template>

<script>
import BasePageComponent from '@/components/common/BasePageComponent'
import UpLoadImage from '@/components/common/UpLoadImage'
import {formatTimeStamp} from '@/utils/dateUtil'

export default {
  name: 'Visitor',
  components: {
    BasePageComponent,
    UpLoadImage,
  },
  data () {
    return {
      tableHeight: 620,
      totalPage: 99,
      pageSize: 20,
      pageNum: 1,
      shareModal: {
        show: false,
        title: '分享设置',
        shareTitle: '',
        picUrl: '',
        rowIndex: 0   //对应的datalist row index
      },
      renameModal: {
        show: false,
        title: '重置名称',
        name: '',
        row: {},
      },
      createPageModal: {
        show: false,
        title: '新建引导页',
        pageTitle: '',
        step: 1,
      },
      columns: [
        {
          title: '姓名',
          key: 'name',
          tooltip: true
        },
        {
          title: '手机',
          key: 'phone',
          tooltip: true
        },
        // {
        //   title: '权限',
        //   slot: 'status',
        //   width: 160,
        // },
        {
          title: '访问次数',
          key: 'guige',
          align: 'center',
          width: 200,
          tooltip: true
        },
        {
          title: '最新访问页面',
          key: 'pageName',
          align: 'center',
          tooltip: true,
        },
        {
          title: '最新访问时间',
          key: 'updateTime',
          width: 175,
          align: 'left'
        },
        {
          title: '操作',
          slot: 'operation',
          width: 320
        }
      ],
      dataList: [
        {
          id: 1,
          name: '张三',
          phone: '15221995660',
          guige: '1212',
          price: '123',
          updateTime: '2020-01-01 12:00:00',
          status: 1,
          pageName: '首页',
          share: {
            title: '',
            picUrl: '',
          },
        },
        {
          id: 2,
          name: '李四',
          updateTime: '2020-01-01 12:00:00',
          status: 2,
          category: '分类1',
          phone: '15221995660',
          guige: '1212',
          price: '123',
          pageName: '其他',
          share: {
            title: '',
            picUrl: '',
          },
        },
        {
          id: 1,
          name: '王五',
          updateTime: '2020-01-01 12:00:00',
          status: 1,
          category: '分类1',
          phone: '15221995660',
          guige: '1212',
          price: '123',
          pageName: '论坛',
          share: {
            title: '',
            picUrl: '',
          },
        },
        {
          id: 2,
          name: '孙六',
          updateTime: '2020-01-01 12:00:00',
          status: 2,
          category: '分类1',
          phone: '15221995660',
          guige: '1212',
          price: '123',
          pageName: '根六福商品详情',
          share: {
            title: '',
            picUrl: '',
          },
        },
      ]
    }
  },
  mounted () {
    this.init()
  },
  activated () {
    this.setTableHeight()
  },
  methods: {
    init () {
      this.setTableHeight()
    },
    setTableHeight(){
      this.tableHeight = window.innerHeight - 250
      window.onresize = () => {
        this.tableHeight = window.innerHeight - 250
      }
    },
    copy (e) {
      this.$Message.info('复制成功')
    },
    onError (e) {
      this.$Message.info('复制失败')
    },
    getStatus (row) {
      if (row.status === 1) {
        return 'red'
      } else {
        return 'green'
      }
    },
    // getUnableStatus(row, index) {
    //   if (index < 2) {
    //   return '#3B80FF'
    //   } else {
    //     return '#BBBBBB'
    //   }
    // },
    onPageRenovationClick (row) {
    },

    createNewPage () {
      this.createPageModal.step = 1
      this.createPageModal.pageTitle = ''
      this.createPageModal.show = true
    },
    createPageModalCancel () {
      this.createPageModal.step = 1
      this.createPageModal.show = false
    },
    createPageModalOk () {
      if (this.createPageModal.step === 1) {
        if (this.createPageModal.pageTitle) {
          //模拟添加数据
          this.dataList.push(
            {
              id: 1,
              name: this.createPageModal.pageTitle,
              updateTime: formatTimeStamp(new Date()),
              status: 2,
              share: {
                title: '',
                picUrl: '',
              },
            },
          )
          this.createPageModal.step = 2
        } else {
          this.$Message.info('页面名称不能为空')
        }
      } else {
        this.createPageModal.show = false
        this.toRenovation()
      }
    },
    toRenovation () {
      const {href} = this.$router.resolve({
        path: '/renovation',
        query: {
          title: this.createPageModal.pageTitle,
          from: 'GuidePage',
        }
      })
      window.open(href, 'guidepage')
    },

    onShareSettingClick (row, index) {                     //点击分享设置
      this.shareModal = {
        show: true,
        title: row.name + ' 分享设置',
        shareTitle: row.share.title,
        picUrl: row.share.picUrl,
        rowIndex: index,
      }
    },
    onUploadShareCoverSuccess (data) {            //分享设置上传图片成功
      if (data && data.length) {
        this.shareModal.picUrl = data[0].url
      }
    },
    onDelShareCoverSuccess () {                   //分享设置删除图片
      this.shareModal.picUrl = ''
    },
    shareSettingOk () {                           //分享设置 确定按钮
      if (!this.shareModal.picUrl) {
        this.$Message.info('分享图片不能为空')
        return
      }
      if (!this.shareModal.shareTitle) {
        this.$Message.info('分享标题不能为空')
        return
      }
      this.shareModal.show = false
      let rowIndex = this.shareModal.rowIndex
      this.dataList[rowIndex].share = {
        title: this.shareModal.shareTitle,
        picUrl: this.shareModal.picUrl,
      }
    },
    shareSettingCancel () {                       //分享设置 取消按钮
      this.shareModal.show = false
    },
    onRenameClick (row) {                         //重置名称
      this.renameModal = {
        show: true,
        name: row.name,
        row: row,
      }
    },

    renameModalCancel () {                        //重置名称 确认
      this.renameModal.show = false
    },
    renameModalOk () {                            ////重置名称 取消
      if (!this.renameModal.name) {
        this.$Message.info('名称不能为空')
        return
      }
      this.renameModal.show = false
      this.renameModal.row.name = this.renameModal.name
    },
    //删除页面
    delPage (row, index) {
      const content = '<p>确定要删除页面 ' + row.name + ' 吗?</p>'
      this.$Modal.confirm({
        title: '提示',
        content: content,
        onOk: () => {
          this.dataList.splice(index, 1)
        },
        onCancel: () => {
        }
      })
    },

    //停用 发布页面
    changeStatus (row, index) {
      const operator = row.status === 1 ? '停用' : '发布'
      var page = row.name
      this.$Modal.confirm({
        title: '提示',
        content: '确定要' + operator + '页面 ' + page + ' 吗?',
        onOk: () => {
          let list = this.dataList
          list[index].status === 1 ? list[index].status = 2 : list[index].status = 1
          console.log('sss')
        },
        onCancel: () => {
        }
      })
    },
  }
}
</script>

<style lang="scss" scoped>
  .modal-setting ::v-deep {

    .ivu-modal-body {
      padding: 0;
      display: flex;
      justify-content: center;
      align-content: center;
    }

    //标题下横线
    .ivu-modal-header {
      border-bottom: none;
    }

    //确认取消按钮上面红线
    .ivu-modal-footer {
      border-top: none;
    }
  }
</style>
